module.exports = __webpack_public_path__ + "img/bow.hunting.c5eab3ba.png";